/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return */
import { IGeneralRequestResponse } from '@services/httpClientService';

export const instanceOfGeneralRequestResponse = <T>(object: any): object is IGeneralRequestResponse<T> => {
  // noinspection OverlyComplexBooleanExpressionJS
  return (
    object !== null &&
    (object.data === null || typeof object.data === 'object') &&
    Array.isArray(object.messages) &&
    object.messages.every((message: any) => typeof message === 'string')
  );
};
